"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var usePasswordViewToggle_1 = __importDefault(require("../Fields/hooks/usePasswordViewToggle"));
var InputField_1 = __importDefault(require("../Fields/InputField"));
exports.default = react_1.default.forwardRef(function NewPasswordField(props, ref) {
    var validate = props.validate, _a = props.name, name = _a === void 0 ? 'newPassword' : _a, rest = __rest(props, ["validate", "name"]);
    var _b = (0, usePasswordViewToggle_1.default)(), type = _b.type, iconName = _b.iconName, onPasswordViewToggle = _b.onPasswordViewToggle;
    var validatePassword = function (value) {
        if (/\s/g.test(value)) {
            return 'No spaces';
        }
        if (value.length < 8) {
            return 'Password must be at least 8 characters long';
        }
        return validate === null || validate === void 0 ? void 0 : validate(value);
    };
    return (react_1.default.createElement(InputField_1.default, __assign({ ref: ref, name: name, label: 'New Password', placeholder: 'New Password', validate: validatePassword, type: type, autoComplete: 'new-password', iconName: iconName, onIconClick: onPasswordViewToggle }, rest)));
});
